import axios from 'axios';

const URL_API_ALBARAN = process.env.VUE_APP_URL_API_ALBARAN;

function getUrlApiTpvComs() {
  const instalacion = localStorage.getItem('instalacion');
  return `https://${instalacion}.sistema4.com:1628/tpv-coms/`;
}

export class AlbaranApiService {
 
  // modo: 'entrada' (default) or 'salida'
  getAlbaranesCab(opUid, modo = 'entrada') {
    let config = {
      headers: {'Authorization': opUid, 'Accept' : 'application/json'}
    };
    const endpoint = modo === 'salida' ? 'salidas' : 'entradas'
    const url = `${getUrlApiTpvComs()}${endpoint}`;
    return axios
      .get(url,config)
      .then(function(response) {
        return response.data;
       
      })
      .catch(function(error) {
        if (error.response && (error.response.status===401 || error.response.status===403)){
          window.location.href = process.env.BASE_URL + '#/logout'
        }
        throw error;
      });
  }
  getBultos(opUid) {
    let config = {
      headers: {'Authorization': opUid, 'Accept' : 'application/json'}
    };
    const url = `${getUrlApiTpvComs()}entradas-bultos`;
    return axios
      .get(url,config)
      .then(function(response) {
        return response.data;
       
      })
      .catch(function(error) {
        if (error.response && (error.response.status===401 || error.response.status===403)){
          window.location.href = process.env.BASE_URL + '#/logout'
        }
        throw error;
      });
  }
  // modo: 'entrada' (default) or 'salida'
  getAlbaranDetalle(opUid, uid, modo = 'entrada') {
    let config = {
      headers: {'Authorization': opUid, 'Accept' : 'application/json'}
    };
    const base = modo === 'salida' ? 'salidas' : 'entradas'
    const url = `${getUrlApiTpvComs()}${base}/${uid}`;
    return axios
      .get(url,config)
      .then(function(response) {
        return response.data;
       
      })
      .catch(function(error) {
        if (error.response && (error.response.status===401 || error.response.status===403)){
          window.location.href = process.env.BASE_URL + '#/logout'
        }
        throw error;
      });
  }
  getBultoDetalle(opUid, uid) {
    let config = {
      headers: {'Authorization': opUid, 'Accept' : 'application/json'}
    };
    const url = `${getUrlApiTpvComs()}entradas-bultos/${uid}`;
    return axios
      .get(url,config)
      .then(function(response) {
        return response.data;
       
      })
      .catch(function(error) {
        if (error.response && (error.response.status===401 || error.response.status===403)){
          window.location.href = process.env.BASE_URL + '#/logout'
        }
        throw error;
      });
  }
  enviarEntrada(entrada) {
    let config = {
      headers: {'Authorization': localStorage.getItem("token"), 'instalacion' : localStorage.getItem("instalacion")}
    };
    const url = `${URL_API_ALBARAN}enviarEntrada`;
    return axios
      .post(url, entrada, config)
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        if (error.response && (error.response.status===401 || error.response.status===403)){
          window.location.href = process.env.BASE_URL + '#/logout'
        }
        throw error;
      });
  }
  enviarSalida(salida) {
    let config = {
      headers: {'Authorization': localStorage.getItem("token"), 'instalacion' : localStorage.getItem("instalacion")}
    };
    const url = `${URL_API_ALBARAN}enviarSalida`;
    return axios
      .post(url, salida, config)
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        if (error.response && (error.response.status===401 || error.response.status===403)){
          window.location.href = process.env.BASE_URL + '#/logout'
        }
        throw error;
      });
  }
}